import React, { useState } from "react";

const faqs = [
  {
    question: "What is the price of a private theater in Delhi?",
    answer:
      "Pricing depends on the room selected, duration, and add-ons chosen. Cine Celebrate offers affordable private theater packages in Laxmi Nagar, Delhi for different celebration needs.",
  },
  {
    question: "Is Cine Celebrate located in Laxmi Nagar?",
    answer:
      "Yes, our private theater is located in Laxmi Nagar, Delhi, easily accessible for guests across Delhi NCR.",
  },
  {
    question:
      "What makes Cine Celebrate the best private theatre in Delhi for anniversary celebration?",
    answer:
      "Cine Celebrate offers a fully private and romantic theatre experience where couples can celebrate their anniversary by watching their favorite movies or personal memories on a big screen in a cozy and exclusive setting.",
  },
  {
    question: "Can I play my own videos during the celebration?",
    answer:
      "Yes. You can stream your favourite movies or play personal videos, slideshows, and music on the big screen during your private screening.",
  },
  {
    question: "Is decoration included in the booking?",
    answer:
      "Basic setup is included, and you can choose customised add-ons such as balloon décor, themed arrangements, LED displays, cakes, and food packages.",
  },
  {
    question:
      "Why choose Cine Celebrate as a private theatre in Delhi for birthday celebration?",
    answer:
      "Cine Celebrate offers a unique birthday experience where you can enjoy your favorite movies, personal videos, and surprise moments on a big screen in a fully private theatre setting.",
  },
];

const HomeFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="home-faq" aria-labelledby="home-faq-heading">
      <div className="home-faq__intro">
        <p className="home-faq__eyebrow">Frequently Asked Questions</p>
        <h2 id="home-faq-heading" className="home-faq__title">
          Answers to the questions guests ask most before booking
        </h2>
      </div>

      <div className="home-faq__accordion">
        {faqs.map((faq, index) => (
          <article
            key={index}
            className={`home-faq__item ${
              activeIndex === index ? "is-active" : ""
            }`}
          >
            <button
              type="button"
              className="home-faq__question"
              onClick={() => handleToggle(index)}
              aria-expanded={activeIndex === index}
              aria-controls={`home-faq-answer-${index}`}
            >
              <span className="home-faq__question-text">{faq.question}</span>
              <span className="home-faq__icon" aria-hidden="true">
                {activeIndex === index ? "−" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div
                id={`home-faq-answer-${index}`}
                className="home-faq__answer"
              >
                <p>{faq.answer}</p>
              </div>
            )}
          </article>
        ))}
      </div>
    </section>
  );
};

export default HomeFAQ;
